<script setup>
defineProps({
  content: {
    tye: Object,
  },
  header: String,
})

function cardHref(content) {
  return rootedPath(content.link?.cached_url || content.link?.url || '')
}

function downloadHref(content) {
  return rootedPath(content.link?.cached_url || content.media?.filename || content.link?.url || '')
}
</script>

<template>
  <nuxt-link
    v-if="!content.target"
    :to="cardHref(content)"
    class="md:justify-normal relative z-0 w-full flex flex-col origin-center cursor-pointer justify-center border border-secondary-gray-200 rounded-lg bg-white px-4 py-6 transition duration-200 ease-linear md:flex-row md:items-center md:px-6"
  >
    <div
      class="w-full flex flex-col gap-x-8 md:flex-row"
    >
      <div class="my-auto">
        <h3 v-if="content.title" :class="header" class="mb-2 text-lg font-semibold text-primary md:text-xl">
          {{ content.title }}
        </h3>
        <p v-if="content.subtitle" class="mb-0 text-md font-medium">
          {{ content.subtitle }}
        </p>
      </div>
      <div class="mt-custom-lg flex flex-wrap items-center gap-x-6 gap-y-4 md:ml-auto md:mt-0 md:flex-nowrap">
        <slot name="btn" />
      </div>
    </div>
  </nuxt-link>
  <a
    v-else
    :href="downloadHref(content)"
    target="_blank"
    class="md:justify-normal relative z-0 w-full flex flex-col origin-center cursor-pointer justify-center border border-secondary-gray-200 rounded-lg bg-white px-4 py-6 transition duration-200 ease-linear md:flex-row md:items-center md:px-6"
  >
    <div
      class="w-full flex flex-col gap-x-8 md:flex-row"
    >
      <div class="my-auto">
        <h3 v-if="content.title" :class="header" class="mb-2 text-lg font-semibold text-primary md:text-xl">
          {{ content.title }}
        </h3>
        <p v-if="content.subtitle" class="mb-0 leading-6 text-[15px] font-normal max-w-3xl">
          {{ content.subtitle }}
        </p>
      </div>
      <div class="mt-custom-lg flex flex-wrap items-center gap-x-6 gap-y-4 md:ml-auto md:mt-0 md:flex-nowrap whitespace-nowrap">
        <slot name="btn" />
      </div>
    </div>
  </a>
</template>
